import { render, staticRenderFns } from "./PdpCarousel.vue?vue&type=template&id=6ca9b2c0&scoped=true&"
import script from "./PdpCarousel.vue?vue&type=script&lang=ts&"
export * from "./PdpCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./PdpCarousel.vue?vue&type=style&index=0&id=6ca9b2c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca9b2c0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default,FCSwiperThumbs: require('/opt/build/repo/apps/shop/components/FCSwiperThumbs.vue').default})
